import React, { useState } from 'react';
import ButtonOptionSelector from './button-option-selector';

function ButtonOptionSelectors({ options, selected, onChange }) {
  const $optionsSelectors = (options || []).map(option => {
    return (
      <ButtonOptionSelector
        name={option.name}
        type={option.type}
        id={option.id}
        key={option.name}
        options={option.options}
        selected={selected}
        handleChange={onChange}
        asset={option.asset}
      />
    );
  });
  //
  return (
    <div>
      <div className="clearfix filter filter__multiple-choice">
        {$optionsSelectors}
      </div>
    </div>
  );
}

export default ButtonOptionSelectors;
